import React, { useEffect, useState } from 'react';
import SwiperCore, {
  Navigation,
  Pagination,
  Autoplay,
  A11y,
  Mousewheel,
} from 'swiper';
import { Swiper, SwiperSlide } from 'swiper/react';
import CardMedia from '@material-ui/core/CardMedia';
import Card from '@material-ui/core/Card';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';
import List from '@material-ui/core/List';
import Link from '@material-ui/core/Link';
import ListItem from '@material-ui/core/ListItem';

import { useAPI } from '../../utils/api';

import ImgDemoHomepageCover from '../../images/demo/demo-homepage-cover.png';
import ErrorHolder from '../../components/errorHolder';
import ColorChip from '../../components/colorChip';

// Import Swiper styles
import 'swiper/swiper.scss';
import 'swiper/components/navigation/navigation.scss';
import 'swiper/components/pagination/pagination.scss';

SwiperCore.use([Navigation, Pagination, A11y, Autoplay, Mousewheel]);

const HomePage = () => {
  const api = useAPI();

  const [newsList, setNewsList] = useState([]);
  const [banners, setBanners] = useState([]);
  const [loadError, setLoadError] = useState(false);

  useEffect(() => {
    api
      .getHomepageBanners()
      .then((result) => {
        if (result.length > 0) {
          setBanners(result.slice(0, 5));
        }
      })
      .catch(() => {
        setLoadError(true);
      });

    api
      .getHomepageNews()
      .then((result) => {
        if (result.length > 0) {
          setNewsList(result);
        }
      })
      .catch(() => {
        setLoadError(true);
      });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      {loadError ? (
        <ErrorHolder text="載入時發生錯誤" />
      ) : (
        <Box
          sx={{ maxHeight: '500px', width: { xs: '95%', md: '90%' } }}
          className="mx-auto"
        >
          <Swiper
            loop
            spaceBetween={50}
            slidesPerView={1}
            navigation
            pagination={{ clickable: true }}
            autoplay={{ delay: 5000, disableOnInteraction: false }}
            mousewheel
            className="mb-4"
            observer
            observeParents
            observeSlideChildren
            resizeObserver
          >
            {banners && banners.length > 0
              ? banners.map((banner, index) => (
                  <SwiperSlide key={index}>
                    <Link underline="none" href={banner.link}>
                      <CardMedia
                        sx={{
                          height: '45vw',
                          maxHeight: '400px',
                          minHeight: '180px',
                        }}
                        image={banner.img || ImgDemoHomepageCover}
                        title="首頁蓋板"
                      />
                    </Link>
                  </SwiperSlide>
                ))
              : undefined}
          </Swiper>

          <Card sx={{ padding: '1rem' }}>
            <Typography
              gutterBottom
              variant="subtitle"
              component="div"
              sx={{ fontWeight: 'bold' }}
            >
              最新消息
            </Typography>
            <List component="div" aria-label="mailbox folders">
              {newsList.map((news, index) => (
                <ListItem
                  key={index}
                  button
                  divider={index < newsList.length - 1}
                  sx={{
                    display: { xs: 'block', sm: 'flex' },
                    marginBottom: { xs: '0.5rem', sm: 0 },
                  }}
                >
                  <Box
                    sx={{
                      display: 'flex',
                      marginBottom: { xs: '0.5rem', sm: 0 },
                      alignItems: 'center',
                    }}
                  >
                    <ColorChip
                      className="mr-4"
                      label={news.label}
                      {...news.tag}
                    />
                    <Typography
                      variant="body2"
                      color="gray"
                      sx={{ marginRight: '1rem' }}
                    >
                      {news.date}
                    </Typography>
                  </Box>
                  <Typography variant="body2">{news.title}</Typography>
                </ListItem>
              ))}
            </List>
          </Card>
        </Box>
      )}
    </>
  );
};

export default HomePage;
